import axios from 'axios';

const Api = axios.create({
  baseURL: `${import.meta.env.VITE_APP_API_URL}/api`,
  withCredentials: true,
  withXSRFToken: true,
  headers: {
    Accept: 'application/json',
  },
});

export default Api;
